'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationCustomerInfoController = function () {
    function WinresReservationCustomerInfoController($scope, $filter, $timeout, userService, $window, $rootScope) {
        var _this = this;

        _classCallCheck(this, WinresReservationCustomerInfoController);

        this.ready = false;

        this.$scope = $scope;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.userService = userService;

        this.messageToBooking = "";
        this.displayPP = true;
        this.displayMarketing = true;
        this.displayElectronicMarketing = true;
        this.$window = $window;
        this.$rootScope = $rootScope;
        this.$rootScope.$on('userDataChanged', function () {
            return _this.getMarketingPermissions();
        });
    }

    _createClass(WinresReservationCustomerInfoController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            if (!this.winresReservationContext) {
                this.winresReservationContext = this.context;
            }
            this.data = this.winresReservationContext.getContext();

            if (this.data.mustWaitDeparture) {
                console.log('[WRCI]', 'Waiting until the departure has loaded.');
                var unwatch = this.$scope.$watch(function () {
                    return _this2.data.mustWaitDeparture;
                }, function (mwd) {
                    if (mwd) return;
                    console.log('[WRCI]', 'The departure has loaded.');
                    unwatch();
                    _this2.initInternal();
                    _this2.ready = true;
                });
            } else {
                this.initInternal();
                this.ready = true;
            }
        }
    }, {
        key: 'initInternal',
        value: function initInternal() {
            var _this3 = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Customer
            // getContext().InvoiceCustomer
            // getContext().Passengers
            // getContext().Customer
            // getContext().AcceptTerms
            // getForceGender()
            // getFieldTitleOverride()
            // getPassengerFieldSettings()
            // getPassengerFields()
            // getReservationTermsOpener()

            // Set:
            // setMessageToBooking()
            // setReservationComponentErrors()
            // getContext().Passengers
            // getContext().Customer
            // getContext().AcceptPrivacyPolicy

            this.getPrivacyPolicy();

            if (this.askMsgToBooking === "true") {
                this.$scope.$watch('$ctrl.messageToBooking', function () {
                    _this3.winresReservationContext.setMessageToBooking(_this3.messageToBooking);
                });
            }

            if (!this.data.Customer) {
                this.data.Customer = {
                    // Finland is default selection if countryOrder is not set
                    Country: this.countryOrder ? null : 'FI',
                    SubGroup: this.setSubgroup ? this.setSubgroup : ''
                };
            } else if (this.countryOrder) {
                this.data.Customer.Country = null;
            }

            if (!this.data.InvoiceCustomer) {
                this.bill_different_address = false;
            } else {
                this.bill_different_address = true;
            }

            this.customerIsPassenger = this.customerIsPassengerInitial === 'true';

            if (this.data.Passengers && _.some(this.data.Passengers, function (p) {
                return p.IsCustomer;
            })) {
                this.customerIsPassenger = true;
            }

            this.$scope.$watch('$ctrl.data.AcceptTerms', function () {
                _this3.validate();
            });

            this.$scope.$watch('$ctrl.bill_different_address', function (value) {
                if (value) {
                    if (!_this3.data.InvoiceCustomer) {
                        _this3.data.InvoiceCustomer = {
                            // Finland is default selection if countryOrder is not set
                            Country: _this3.countryOrder ? null : 'FI',
                            SubGroup: _this3.setSubgroup ? _this3.setSubgroup : ''
                        };
                    } else if (_this3.countryOrder) {
                        _this3.data.InvoiceCustomer.Country = null;
                    }
                } else {
                    _this3.data.InvoiceCustomer = null;
                }
                _this3.validate();
            });

            if (this.copyFromPassenger === 'true') {
                this.$scope.$watch('$ctrl.data.Passengers[0]', function (passenger, oldPassenger) {
                    _this3.updateCustomerFromPassenger(passenger, oldPassenger);
                }, true);
            }

            this.$scope.$watchGroup(['$ctrl.data.Passengers', '$ctrl.customerIsPassenger'], function (value) {
                var customer = _this3.data.Customer;
                _this3.validate();

                if (!_this3.data.Passengers) {
                    // Passenger names will be given later.
                    return;
                }
                if (_this3.data.Passengers.length == 0) {
                    _this3.data.Passengers = [{}];
                }
                var customerPassenger = _this3.data.Passengers[0];

                // Hide customer passenger
                if (_this3.customerIsPassenger === true) {
                    /*
                    var customerPassenger = _.find(this.data.Passengers,
                        passenger => passenger.IsCustomer);
                    if (!customerPassenger) {
                        customerPassenger = { IsCustomer: true, IsLocked: true, IsHidden: true };
                        this.data.Passengers.unshift(customerPassenger);
                    }
                    */
                    // console.log("[CustomerInfo] customerPassenger: ", customerPassenger);
                    customerPassenger.IsCustomer = true;
                    customerPassenger.IsLocked = true;
                    customerPassenger.IsHidden = true;

                    var g = _this3.winresReservationContext.getForceGender();
                    if (g) {
                        customerPassenger['Gender'] = g;
                    }

                    _this3.updatePassengerFromCustomer();
                } else {
                    customerPassenger.IsCustomer = false;
                    customerPassenger.IsLocked = false;
                    customerPassenger.IsHidden = false;
                    // Customer is not a passenger - remove the customer passenger.
                    /*
                      _.remove(this.data.Passengers,
                               passenger => passenger.IsCustomer);
                               */
                }

                _this3.initializeFields();
            });

            this.$scope.$watch('$ctrl.data.Customer', function (customer) {
                _this3.validate();
                _this3.updatePassengerFromCustomer();
            }, true);

            this.$scope.$watch('$ctrl.data.InvoiceCustomer', function () {
                return _this3.validate();
            }, true);

            this.$scope.$watch('$ctrl.data.Destination', function () {
                return _this3.initializeFields();
            });
            //this.initializeFields();

            this.termsSwitch = this.termsSwitch;
            this.validate();

            this.$scope.$watch('$ctrl.customerPassenger', function () {
                _this3.validate();
            }, true);

            //this.$scope.$watch('$ctrl.data', () => {
            //this.$scope.$watch('$ctrl.data.Passengers[0]', () => {
            this.$scope.$watchCollection('$ctrl.data.Passengers', function () {
                if (_this3.data.Passengers && _this3.data.Passengers.length > 0) {
                    _this3.customerPassenger = _this3.data.Passengers[0];
                }
            }, true);

            this.$scope.$watchGroup(['$ctrl.data.NumAdults', '$ctrl.data.NumChildren', '$ctrl.data.NumInfants'], function () {
                _this3.numPeople = _this3.data.NumAdults + _this3.data.NumChildren + _this3.data.NumInfants;
            });

            //this.getMarketingPermissions();

            if (this.onInit) {
                this.onInit({ controller: this });
            }
        }
    }, {
        key: 'updateCustomerFromPassenger',
        value: function updateCustomerFromPassenger(passenger, oldPassenger) {
            if (!passenger || !oldPassenger || !this.customerForm) {
                return;
            }

            if (this.customerForm.FirstName.$pristine && this.customerForm.LastName.$pristine && oldPassenger.FirstName == this.data.Customer.FirstName && oldPassenger.LastName == this.data.Customer.LastName) {
                this.data.Customer.FirstName = passenger.FirstName;
                this.data.Customer.LastName = passenger.LastName;
            }
        }
    }, {
        key: 'updatePassengerFromCustomer',
        value: function updatePassengerFromCustomer() {
            var _this4 = this;

            if (!this.customerIsPassenger) {
                return;
            }
            var customerPassenger = _.find(this.data.Passengers, function (passenger) {
                return passenger.IsCustomer;
            });

            if (!customerPassenger) {
                return;
            }

            _.each(this.data.Customer, function (value, index) {
                switch (index) {
                    case 'PostalAddress':
                        customerPassenger.PostAddress = value;
                        break;
                    case 'EmailAddress':
                        customerPassenger.Email = value;
                        break;
                    case 'PhoneNumber':
                        customerPassenger.TelephoneNo = value;
                        break;
                    default:
                        customerPassenger[index] = _this4.data.Customer[index];
                }
            });
        }

        // Initializes structure containing all fields.

    }, {
        key: 'initializeFields',
        value: function initializeFields() {
            var _this5 = this;

            if (!this.fields) {
                this.askFirstName = this.askFirstName === 'true';
                this.askLastName = this.askLastName === 'true';
                this.askStreetAddress = this.askStreetAddress === 'true';
                this.askPostalNumber = this.askPostalNumber === 'true';
                this.askPostalAddress = this.askPostalAddress === 'true';
                this.askPhoneNumber = this.askPhoneNumber === 'true';
                this.askEmailAddress = this.askEmailAddress === 'true';
                this.askCountry = this.askCountry === 'true';
                this.askCompanyName = this.askCompanyName === 'true';

                if (!this.hideNotAskedFields) {
                    this.askFirstName = true;
                    this.askLastName = true;
                    this.askStreetAddress = true;
                    this.askPostalNumber = true;
                    this.askPostalAddress = true;
                    this.askPhoneNumber = true;
                    this.askEmailAddress = true;
                    this.askCountry = true;
                    this.askCompanyName = true;
                }
            }

            this.fields = [{
                Name: 'Gender',
                Title: 'reservation_customer.Gender',
                Required: true,
                Ask: true
            }, {
                Name: 'FirstName',
                Title: 'reservation_customer.first_name',
                Required: true,
                MaxLength: 25,
                Ask: this.askFirstName,
                Autocomplete: 'given-name'
            }, {
                Name: 'LastName',
                Title: 'reservation_customer.last_name',
                Required: true,
                MaxLength: 30,
                Ask: this.askLastName,
                Autocomplete: 'family-name'
            }, {
                Name: 'StreetAddress',
                Title: 'reservation_customer.street_address',
                Required: true,
                MaxLength: 60,
                Ask: this.askStreetAddress,
                Autocomplete: 'shipping street-address'
            }, {
                Name: 'PostalNumber',
                Title: 'reservation_customer.postal_number',
                Required: true,
                MaxLength: 20,
                Ask: this.askPostalNumber,
                Autocomplete: 'shipping postal-code'
            }, {
                Name: 'PostalAddress',
                Title: 'reservation_customer.postal_address',
                Required: true,
                MaxLength: 40,
                Ask: this.askPostalAddress,
                Autocomplete: 'shipping locality'
            }, {
                Name: 'PhoneNumber',
                Title: 'reservation_customer.phone_number',
                Required: true,
                MaxLength: 20,
                Ask: this.askPhoneNumber,
                Autocomplete: 'tel'
            }, {
                // Note: this field has special handling in template
                Name: 'EmailAddress',
                Title: 'reservation_customer.email',
                Required: true,
                MaxLength: 60,
                Ask: this.askEmailAddress,
                Autocomplete: 'email'
            }, {
                // Note: this field has special handling in template
                Name: 'Country',
                Title: 'reservation_customer.country',
                Required: true,
                Ask: this.askCountry,
                Autocomplete: 'shipping country'
            }, {
                Name: 'CompanyName',
                Title: 'reservation_customer.company_name',
                Required: this.requireCompany == 'true',
                MaxLength: 60,
                Ask: this.askCompanyName,
                Autocomplete: 'company'
            }];

            _.each(this.fields, function (field) {
                switch (_this5['ask' + field.Name]) {
                    case 'true':
                        field.Required = false;
                        break;
                    case 'false':
                        field.Ask = false;
                        field.Required = false;
                        break;
                    case 'require':
                        field.Required = true;
                        break;
                }
            });

            if (this.fillNotAskedFields) _.each(this.fields, function (field) {
                if (!field.Ask) _this5.data.Customer[field.Name] = _this5.fillNotAskedFields;
            });

            this.invoiceFields = _.cloneDeep(this.fields);

            // Do not override invoice customer fields - e.g. if Company is
            // "football club" in the form, it should not be that for the payer
            _.each(this.fields, function (field) {
                var override = _this5.winresReservationContext.getFieldTitleOverride(field.Name);
                if (override) {
                    field.Title = override;
                }
            });

            // Is company required differs for invoice customer
            if (this.askCompanyNameInvoice) {
                var companyField = _.find(this.invoiceFields, function (field) {
                    return field.Name == 'CompanyName';
                });
                companyField.Required = this.askCompanyNameInvoice == 'require';
                companyField.Ask = this.askCompanyNameInvoice != 'false';
            }

            if (this.data.Destination && this.customerIsPassenger) {
                var settings = this.winresReservationContext.getPassengerFieldSettings();
                //Destination might not have loaded
                // console.log("[CustomerInfo] Passenger fields: ",this.winresReservationContext.getPassengerFields());
                // console.log("[CustomerInfo] Passenger fields settings: ", this.winresReservationContext.getPassengerFieldSettings());

                _.each(this.winresReservationContext.getPassengerFields(), function (field) {
                    if (field.Name == 'Email' || field.Name == 'TelephoneNo' || field.Name == 'PostAddress') {
                        return;
                    }
                    if (_.some(_this5.fields, function (f) {
                        return f.Name == field.Name;
                    })) {
                        return;
                    }
                    var fs = settings[field.Name];
                    if (fs.Ask) {
                        // console.log('[CustomerInfo] Pushing', field);
                        field.Title = fs.Title || 'reservation_customer.' + field.Name;
                        field.Ask = fs.Ask;
                        field.Required = fs.Required;
                        field.AllowedValues = fs.AllowedValues;
                        field.Type = fs.Type;
                        _this5.fields.push(field);
                    }
                });
            }

            // fix for that if company is only asked in invoice

            if (this.customerIsPassenger === false && this.askCompanyNameInvoice != 'false') {
                var index = _.findIndex(this.fields, function (field) {
                    return field.Name == 'CompanyName';
                });
                this.fields[index].Ask = true;
                this.fields[index].Require = true;
                //moves the company field to first
                var toBeTheFirstField = _.find(this.fields, { Name: 'CompanyName' });
                _.remove(this.fields, { Name: 'CompanyName' });
                this.fields.unshift(toBeTheFirstField, this.fields[index]);
            } else if (this.askCompanyNameInvoice != false) {
                var index = _.findIndex(this.fields, function (field) {
                    return field.Name == 'CompanyName';
                });
                this.fields[index].Ask = false;
                this.fields[index].Require = false;
            }

            // move the spcified field(s) to be the first

            if (this.firstField != null) {
                var firstFields = this.firstField.split(',');
                _.each(firstFields, function (field) {
                    var toBeTheFirstField = _.find(_this5.fields, { Name: field });
                    _.remove(_this5.fields, { Name: field });
                    _this5.fields.unshift(toBeTheFirstField);
                });
            }

            if (this.removeField != null) {
                var removeFields = this.removeField.split(',');
                _.each(removeFields, function (field) {
                    _.remove(_this5.fields, { Name: field });
                });
                return this.fields;
            }

            this.getMarketingPermissions();
        }
    }, {
        key: 'validate',
        value: function validate() {
            var _this6 = this;

            this.$timeout(function () {
                // Check if the form is valid. This should work even if data comes
                // from  session and isthe form is hidden, since the form is
                // directly bound to the data.
                var errors = _this6.validateForm(_this6.customerForm, 'customer');
                if (_this6.bill_different_address) {
                    errors = errors.concat(_this6.validateForm(_this6.billingForm, 'invoice'));
                }

                if (!_this6.data.AcceptTerms && _this6.winresReservationContext.getReservationTermsOpener() && _this6.termsSwitch != 'true') {
                    errors.push('reservation_customer.error_terms');
                }
                if (_this6.mustNotAddPassengers !== 'true') {
                    if (_this6.data.Passengers["0"].FirstName == null && _this6.data.Passengers["0"].IsCustomer) {
                        errors.push('reservation_passenger.error_must_add_passengers');
                    }
                }
                _this6.winresReservationContext.setReservationComponentErrors('passenger', 'customer', errors);
            });
        }
    }, {
        key: 'validateForm',
        value: function validateForm(form, formName) {
            var _this7 = this;

            if (!form) {
                return [];
            }

            // Uniq remove error duplicates.
            return _.uniqBy(_.flatMap(form.$error, function (controls, validatorName) {
                return _.map(controls, function (control) {
                    var title = '$t(reservation_customer.' + control.$name + ')';
                    var settings = _this7.winresReservationContext.getPassengerFieldSettings();

                    var name;
                    if (settings) name = settings[control.$name];

                    if (name && name.Title) {
                        title = name.Title;
                    }

                    return {
                        Message: 'reservation_customer.error_' + formName,
                        Params: {
                            field: title
                        } };
                });
            }), '$name');
        }

        // privacy policy things

    }, {
        key: 'getPrivacyPolicy',
        value: function getPrivacyPolicy() {
            var pp = this.userService.getPrivacyPolicy();
            // console.log("[CustomerInfo] privacy policy link received: ", pp);
            if (pp == false || pp == null) {
                this.displayPP = false;

                // set the privacy policy to true so fields can be edited when there is no privacy policy.
                this.data.AcceptPrivacyPolicy = true;
            } else {
                this.openLink = pp;
                // console.log("[CustomerInfo] privacy policy link this.openLink: ", this.openLink);
            }
        }
    }, {
        key: 'goToLink',
        value: function goToLink() {
            this.$window.open(this.openLink, '_blank');
        }
    }, {
        key: 'getAllowMarketing',
        value: function getAllowMarketing() {
            var _this8 = this;

            this.marketingParams = this.userService.getMarketingParams();

            // console.log("marketing params", this.marketingParams);

            if (this.marketingParams) {
                if (this.data.AllowMarketing == null) this.data.AllowMarketing = this.marketingParams.Selected;

                this.$scope.$watch(function () {
                    return _this8.data.AllowMarketing;
                }, function () {
                    if (_this8.marketingParams.Negative) {
                        _this8.data.Customer.AllowMarketing = !_this8.data.AllowMarketing;
                        _this8.data.Customer.DenyMarketing = _this8.data.AllowMarketing;
                    } else {
                        _this8.data.Customer.AllowMarketing = _this8.data.AllowMarketing;
                        _this8.data.Customer.DenyMarketing = !_this8.data.AllowMarketing;
                    }
                });
            }

            // var marketing = this.userService.getAllowMarketing();
            // if(marketing == null) {
            //     this.displayMarketing = false;
            //     this.data.Customer.AllowMarketing = false;
            // }else{
            //     if(marketing == false) {
            //         this.displayMarketing = false;
            //         this.data.Customer.AllowMarketing = false;
            //     }else{
            //         // this option is not allowed by GPDR thus it is commented out
            //         //this.data.Customer.AllowMarketing = true;
            //     }
            // }
        }
    }, {
        key: 'getAllowElectronicMarketing',
        value: function getAllowElectronicMarketing() {
            var _this9 = this;

            this.electronicMarketingParams = this.userService.getElectronicMarketingParams();

            // console.log("electronic marketing params", this.electronicMarketingParams);

            if (this.electronicMarketingParams) {
                if (this.data.AllowElectronicMarketing == null) this.data.AllowElectronicMarketing = this.electronicMarketingParams.Selected;

                this.$scope.$watch(function () {
                    return _this9.data.AllowElectronicMarketing;
                }, function () {
                    if (_this9.electronicMarketingParams.Negative) {
                        _this9.data.Customer.AllowElectronicMarketing = !_this9.data.AllowElectronicMarketing;
                        _this9.data.Customer.DenyElectronicMarketing = _this9.data.AllowElectronicMarketing;
                    } else {
                        _this9.data.Customer.AllowElectronicMarketing = _this9.data.AllowElectronicMarketing;
                        _this9.data.Customer.DenyElectronicMarketing = !_this9.data.AllowElectronicMarketing;
                    }
                });
            }

            // var ElectronicMarketing = this.userService.getAllowElectronicMarketing();
            // if(ElectronicMarketing == null) {
            //     this.displayElectronicMarketing = false;
            //     this.data.Customer.AllowElectronicMarketing = false;
            // }else{
            //     if(ElectronicMarketing == false) {
            //         this.displayElectronicMarketing = false;
            //         this.data.Customer.AllowElectronicMarketing = false;
            //     }else{
            //         // this option is not allowed by GPDR thus it is commented out
            //         //this.data.Customer.AllowElectronicMarketing = true;
            //     }
            // }
        }
    }, {
        key: 'getMarketingPermissions',
        value: function getMarketingPermissions() {
            if (this.ready) {
                this.getAllowMarketing();
                this.getAllowElectronicMarketing();
            }
        }
    }]);

    return WinresReservationCustomerInfoController;
}();

WinresReservationCustomerInfoController.$inject = ['$scope', '$filter', '$timeout', 'userService', '$window', '$rootScope'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'customer-info';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('customer-info', require('./winresReservationCustomerInfo.html'));
}]);

_module3.default.component('winresReservationCustomerInfo', {
    templateUrl: getTemplate,
    controller: WinresReservationCustomerInfoController,
    require: {
        winresReservationContext: '?^^winresReservationContext'
    },
    bindings: {
        // Show continue button
        showContinueButton: '@',
        askInvoiceCustomer: '@', // true/false default true
        // "false", "true", "require".
        askCompanyName: '@', // Default: 'ask'
        // Special for invoice customer
        askCompanyNameInvoice: '@', // Default: 'require'
        askFirstName: '@', // Default: 'require'
        askLastName: '@', // Default: 'require'
        askStreetAddress: '@', // Default: 'require'
        askPostalNumber: '@', // Default: 'require'
        askPostalAddress: '@', // Default: 'require'
        askPhoneNumber: '@', // Default: 'require'
        askEmailAddress: '@', // Default: 'require' NOTE: Disabling this might not work since reservation confirmation cannot be sent.
        askCountry: '@', // Default: 'require'

        copyFromPassenger: '@', // true/false default false

        setSubgroup: '@', // Set Asiakas.ALARYHMA (SubGroup in Customer)

        // Customer is passenger by default
        customerIsPassengerInitial: '@',

        // Ask if customer is passenger
        askCustomerIsPassenger: '@',

        // Always show customer info regardless which tab is open
        showAlways: '@',

        // asks the terms here, can be also found in winresReservationPayButton and winresReservationPayment
        termsSwitch: '@',

        //changes this field to be the first field displayed, if multiple separate with comma without spaces. Last specified will be first to displayed
        firstField: '@',

        // if multiple separate with comma without spaces
        removeField: '@',

        // set true if passengers are not required. This might need to be added to Oulu/Kymi if those are updated
        mustNotAddPassengers: '@',

        // ask message that is sent to booking, most likely fields needs to be added to template
        askMsgToBooking: '@',

        // Fill not asked fields with
        fillNotAskedFields: '@',

        // Hide not asked fields
        hideNotAskedFields: '@',

        // Countries shown first in country selection. First country in list is set to customer.
        // Seperate countries by comma ex. "FI,SE,RU"
        countryOrder: '@',

        // List only ETA countries
        etaCountries: '@',

        context: '<',

        onInit: '&'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationCustomerInfo/winresReservationCustomerInfo.js
// module id = 369
// module chunks = 2